import { Injectable } from '@angular/core';
import { StateCreator, StoreApi } from 'zustand/vanilla';
import { NzTableSortOrder } from 'ng-zorro-antd/table';

export interface TableState {
  sort?: {
    key: string;
    order: NzTableSortOrder;
  };
  filters: Record<string, string[]>;
  searchFields?: Record<string, string>;
}

export interface TableStateStoreState {
  lockerListTable: TableState | null;
  ClothingListTable: TableState | null;
  provisionListTable: TableState | null;
}

export interface TableStateStoreSlice {
  tables: TableStateStoreState;
}

const initialTableStateStoreState: TableStateStoreState = {
  lockerListTable: null,
  ClothingListTable: null,
  provisionListTable: null,
};

// interface ColumnItem {
//   id: number;
//   name: string;
//   sortOrder: NzTableSortOrder | null;
//   sortFn: NzTableSortFn<Locker> | null;
//   listOfFilter: NzTableFilterList;
//   filterFn: NzTableFilterFn<Locker> | null;
//   showFilter?: boolean;
// }

export interface TableStateStoreActions {
  setLockerTableState: (state: TableState) => void;
  setClothingTableState: (state: TableState) => void;
  setProvisionsTableState: (state: TableState) => void;
  applyFiltersToColumns: (state: TableState, columns: any[]) => void;
  applySortToColumns: (state: TableState, columns: any[]) => void;
  buildTableStateFromQueryParams: (params: any, columns: any[]) => TableState;
  reset: () => void;
}

@Injectable()
export class TableStateStoreService {
  private slice: StateCreator<TableStateStoreSlice>;
  private actions: (
    store: StoreApi<TableStateStoreSlice>,
  ) => TableStateStoreActions;

  constructor() {
    this.slice = () => ({ tables: initialTableStateStoreState });
    this.actions = (store) => ({
      setLockerTableState(tableState) {
        store.setState((state) => ({
          tables: { ...state.tables, lockerListTable: tableState },
        }));
      },
      setClothingTableState(tableState) {
        store.setState((state) => ({
          tables: { ...state.tables, ClothingListTable: tableState },
        }));
      },
      setProvisionsTableState(tableState) {
        store.setState((state) => ({
          tables: { ...state.tables, provisionListTable: tableState },
        }));
      },

      applyFiltersToColumns: (tableState, columns) => {
        if (!tableState?.filters) return;

        for (const column of columns) {
          if (!column.listOfFilter?.length) continue;
          const activeValues = tableState.filters[column.name] ?? [];
          column.listOfFilter.forEach((option: any) => {
            option.byDefault = activeValues.includes(option.value);
          });
        }
      },

      applySortToColumns: (tableState, columns) => {
        for (const column of columns) {
          column.sortOrder = null;
          if (tableState?.sort && column.name === tableState.sort.key) {
            column.sortOrder = tableState.sort.order;
          }
        }
      },

      buildTableStateFromQueryParams: (params, columns) => {
        const filterColumns = columns.filter(
          (c) => c.listOfFilter && c.listOfFilter.length > 0,
        );

        const filters: Record<string, string[]> = {};

        params.filter.forEach((filterParam: any, index: number) => {
          const column = filterColumns[index];
          if (!column) return;
          if (filterParam.value && filterParam.value.length > 0) {
            filters[column.name] = filterParam.value as string[];
          }
        });

        const sortEntry = params.sort
          .map((s: any, index: number) => ({ ...s, index }))
          .find((s: any) => s.value !== null);

        const sort = sortEntry
          ? {
              key: columns[sortEntry.index]?.name,
              order: sortEntry.value,
            }
          : undefined;

        return { sort, filters };
      },

      reset() {
        store.setState({ tables: initialTableStateStoreState });
      },
    });
  }
  getSlice() {
    return this.slice;
  }

  getActions() {
    return this.actions;
  }
}
